import {
	type Area,
	apiAppBusinessAreaUpsert,
	apiAppBusinessAreaDelete
} from '#lib/types/generated/index.js';
import { optimisticDelete, optimisticSave } from '#lib/stores/optimistic.js';
import { derived, writable } from 'svelte/store';

export const areaStore = writable<Area[]>([]);

export function saveArea(area: Area): Promise<Area> {
	return optimisticSave(areaStore, area, () => apiAppBusinessAreaUpsert(area.id, area));
}

export async function deleteArea(area: Area): Promise<void> {
	await optimisticDelete(areaStore, area, () => apiAppBusinessAreaDelete(area.id));
}

export const hasAreasWithMultiplePax = derived(areaStore, ($areaStore) =>
	$areaStore.some((a) => !a.archivedAt && a.capacity > 1)
);
